<template>

  <div>

    <div>

      <el-time-select v-model="value.opens" :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="Opens at"></el-time-select>

      <el-time-select v-model="value.closes" :picker-options="{ start: '00:00', step: '00:15', end: '23:59' }" placeholder="Closes at"></el-time-select>

    </div>

  </div>

</template>
<script>
export default {
  props: ['value'],
  mounted() {

  }
};
</script>



// WEBPACK FOOTER //
// TimeRangePicker.vue?10fdc852